import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

export const Client = ({ values }) => (
  <>
    <div className="row">
      <div className="col-12 ViewOrEdit">
        <div>
          <strong>
            <FormattedMessage id="Nombre:" />
          </strong>
          <span>{get(values, 'customer.firstname', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Correo Electronico:" />
          </strong>
          <span>{get(values, 'customer.email', '-')}</span>
        </div>
      </div>
    </div>
  </>
);

export default Client;
